import * as React from 'react'
import { Button, DatePicker, InputRef, Space } from 'antd'
import { SearchOutlined } from '@ant-design/icons'
import dayjs from 'dayjs'
import isBetween from 'dayjs/plugin/isBetween'
import Highlighter from 'react-highlight-words'
import { handleReset } from './index'
import { Leaves } from '../../../libs/types'
import { rangePresets } from './consts'

export const getColumnSearchDateProps = <Entity,>(
  dataIndex: Leaves<Entity>,
  setSearchText: React.Dispatch<React.SetStateAction<{ [p: string]: string }>>,
  searchText: { [p: string]: string },
  setIsCalendarOpen: React.Dispatch<React.SetStateAction<boolean>>,
  isCalendarOpen: boolean,
  searchInput: React.RefObject<InputRef>,
): {
  filterDropdown: ({
    setSelectedKeys,
    selectedKeys,
    confirm,
    clearFilters,
    close,
  }: {
    setSelectedKeys: any
    selectedKeys: any
    confirm: any
    clearFilters?: any
    close: any
  }) => JSX.Element
  filterIcon: (filtered: boolean) => JSX.Element
  onFilter: (value: any, record: any) => boolean
  render: (text: any) => any
  onFilterDropdownOpenChange: (visible: any) => void
} => ({
  filterDropdown: ({ setSelectedKeys, selectedKeys, close, clearFilters }) => (
    <div style={{ padding: 8 }} onKeyDown={(e) => e.stopPropagation()}>
      <DatePicker.RangePicker
        format="YYYY-MM-DD"
        style={{ marginBottom: 8, display: 'flex' }}
        value={selectedKeys[0]}
        defaultValue={rangePresets && (rangePresets[0].value as any)}
        onChange={(e) => setSelectedKeys(e ? [e] : [])}
        presets={rangePresets}
        open={isCalendarOpen}
        onClick={() => setIsCalendarOpen(true)}
        allowEmpty={[true, true]}
        onCalendarChange={() => setIsCalendarOpen(false)}
      />
      <Space>
        <Button
          type="primary"
          onClick={() =>
            setSearchText((prev) => ({
              ...prev,
              [dataIndex]: selectedKeys[0],
            }))
          }
          icon={<SearchOutlined />}
          size="small"
          style={{ width: 90 }}
        >
          Search
        </Button>
        <Button
          onClick={() =>
            clearFilters && handleReset(clearFilters, dataIndex, setSearchText)
          }
          size="small"
          style={{ width: 90 }}
        >
          Reset
        </Button>
        <Button
          type="link"
          size="small"
          onClick={() => {
            close()
          }}
        >
          close
        </Button>
      </Space>
    </div>
  ),
  filterIcon: (filtered: boolean) => (
    <SearchOutlined style={{ color: filtered ? '#1677ff' : undefined }} />
  ),
  onFilter: (value, record) => {
    dayjs.extend(isBetween)
    return record[dataIndex]
      ? dayjs(record[dataIndex]).isBetween(dayjs(value[0]), dayjs(value[1]))
      : false
  },
  onFilterDropdownOpenChange: (visible) => {
    if (visible) {
      setTimeout(() => searchInput.current?.select(), 100)
    }
  },
  render: (text) =>
    searchText[dataIndex] ? (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[searchText[dataIndex]]}
        textToHighlight={text ? text.toString() : ''}
      />
    ) : (
      text
    ),
})
